<template>
  <div id="mb-grid" :style="{ '--color': color }">
    <b-button
      size="sm"
      v-b-toggle.sidebar-1
      style="background-color: #004899; top: 50%; left: -32px; transform: rotate(-90deg); position: fixed !important"
      v-if="devTool"
    >
      DEV-TOOL
    </b-button>
    <b-sidebar id="sidebar-1" title="DEV-TOOL" shadow v-if="devTool">
      <b-container class="dev-tools">
        <b-row cols="12" align-v="start" class="mb-3">
          <b-col class="pb-1">
            <b-button v-b-toggle.sidebar-1 @click="customRouletteState = true" style="background-color: #004899">
              customRouletteState
            </b-button>
          </b-col>
          <b-col class="pb-1">
            <b-button v-b-toggle.sidebar-1 @click="customCodingState = true" style="background-color: #004899">
              customCodingState
            </b-button>
          </b-col>
          <b-col class="pb-1">
            <b-button @click="redirect('monograph-view')" style="background-color: #004899">monograph</b-button>
          </b-col>
        </b-row>
        <b-row cols="12" align-v="start" class="mb-3">
          <b-col>
            <b-button @click="redirect('config-cjs-view')" variant="warning">CreateJS</b-button>
          </b-col>
        </b-row>
        <b-row cols="12" align-v="start">
          <b-form-input
            @input="findById()"
            type="text"
            v-model="gameId"
            placeholder="Wpisz ID"
            style="z-index: 5"
          ></b-form-input>
        </b-row>
      </b-container>
    </b-sidebar>
    <transition name="modal-fade">
      <mb-custom-roulette
        v-if="customRouletteState"
        @closeCustomRoulette="customRouletteState = false"
      ></mb-custom-roulette>
    </transition>
    <transition name="modal-fade">
      <mb-editor-page v-if="editorPageState" @closeInfo="editorPageState = false"></mb-editor-page>
    </transition>
    <transition name="modal-fade">
      <mb-custom-coding v-if="customCodingState" @closeCustomCoding="customCodingState = false"></mb-custom-coding>
    </transition>
    <!-- <mb-media-bar></mb-media-bar> -->
    <div id="header" v-if="items">
      <img class="header-logo-img" :src="MAClogo" @click="openUrl('https://www.mac.pl')" />
      <img class="header-img" v-if="items.header" :src="items.header" />
      <img
        class="header-home-icon"
        @mouseenter="homeIconStatus = true"
        @mouseleave="homeIconStatus = false"
        @click="redirectMain()"
        :src="homeIcon"
      />
      <transition name="modal-fade">
        <img
          class="header-home-icon"
          @mouseenter="homeIconStatus = true"
          @mouseleave="homeIconStatus = false"
          @click="redirectMain()"
          v-if="homeIconStatus"
          :src="homeOnIcon"
        />
      </transition>
    </div>
    <div
      id="container"
      @on:scroll="handleScroll($event)"
      v-if="items"
      :style="{ backgroundImage: `url('${items.bcg}')`, backgroundColor: 'white' }"
    >
      <!-- <img class="container-bcg" v-if="items.bcg" :src="items.bcg" /> -->
      <div class="container-filter">
        <div class="container-tite" :style="{ backgroundColor: items.mainColor }" v-if="items">
          <span v-html="items.title"></span>
        </div>
        <div class="container-filters">
          <div class="container-filters-header">
            <p>Filtry</p>
            <span @click="clearFilters()">[wyczyść wszystko]</span>
          </div>
          <div class="container-filters-header-filter">
            <div class="filter-main" v-for="(filter, filterId) in filterItems" :key="'filters-key-text-' + filterId">
              <div class="filter-text">{{ filter.title }}</div>
              <div
                :style="[{ paddingLeft: innerFilter.padding - 0.47 + 'vmax' }]"
                v-for="(innerFilter, innerFilterId) in filter.items"
                :key="'filters-key-' + innerFilterId"
              >
                <div
                  v-if="innerFilter.value"
                  class="filter"
                  :style="[
                    innerFilter.collapseDepends && !checkFilterCollapseStatus(innerFilter.collapseDepends)
                      ? { display: 'none', opacity: 0 }
                      : {},
                  ]"
                  :class="{
                    'filter-disable': innerFilter.disable,
                  }"
                >
                  <img
                    draggable="false"
                    :src="setImg(innerFilter.type)"
                    @click="
                      setFilters(
                        innerFilter.type,
                        innerFilter.disable,
                        checkFilterStatus(innerFilter.type),
                        innerFilter.mustContain
                      )
                    "
                    :style="{ backgroundColor: items.mainColor }"
                  />
                  <div
                    class="filter-box"
                    @click="
                      setFilters(
                        innerFilter.type,
                        innerFilter.disable,
                        checkFilterStatus(innerFilter.type),
                        innerFilter.mustContain
                      )
                    "
                  >
                    <div>
                      {{ innerFilter.text }}
                      <span style="color: gray" v-html="' [' + innerFilter.value + ']'"></span>
                    </div>
                  </div>
                  <img
                    draggable="false"
                    style="width: 0.73vmax; height: 0.62vmax"
                    :style="{ backgroundColor: items.mainColor }"
                    v-if="!innerFilter.disable && innerFilter.collapse"
                    :src="setImgCollapse(innerFilter.id)"
                    @click="setFilterCollapse(innerFilter.id)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-tags">
          <div class="container-tags-title" :style="{ color: items.mainColor }">Tagi:</div>
          <vue-word-cloud
            :enter-animation="{ opacity: 0, transform: 'scale3d(0.3,0.3,0.3)' }"
            style="height: 100%; width: 100%"
            :words="createTagArray(false)"
            :color="([, weight]) => (weight > 10 ? items.mainColor : weight > 5 ? items.mainColor : items.mainColor)"
            font-family="Celias"
          ></vue-word-cloud>
        </div>
      </div>
      <div class="container-elements" id="container-elements" :style="{ backgroundColor: items.mainColor + '30' }">
        <div class="container-elements-header">
          <div style="height: calc(0.1 * 90vh * 0.6); width: calc(0.1 * 90vh * 0.6)">
            <svg
              class="style-changer"
              @click="setContainerStyle()"
              width="100%"
              height="100%"
              @mouseenter="gridIconHover = true"
              @mouseleave="gridIconHover = false"
              viewBox="0 0 90 90"
              style="transition: 0.5s"
              :style="[gridIconHover ? { backgroundColor: 'white' } : { backgroundColor: items.mainColor }]"
            >
              <path
                stroke-width="3"
                fill="transparent"
                stroke="white"
                d="M0,0 90,0 90,90, 0,90Z"
                style="transition: 0.5s"
                :style="[gridIconHover ? { stroke: items.mainColor } : { stroke: 'white' }]"
              />
              <path
                stroke-width="3"
                fill="transparent"
                stroke="white"
                :d="setSvgPath()"
                style="transition: 0.5s"
                :style="[gridIconHover ? { stroke: items.mainColor } : { stroke: 'white' }]"
              />
            </svg>
          </div>
        </div>
        <div class="containter-content">
          <div
            class="container-elements-main"
            :class="{
              'container-elements-main-grid': elementsType == 'grid',
              'container-elements-main-list': elementsType == 'list',
            }"
            v-if="filteredItems"
          >
            <div
              :class="{
                'main-container-element': elementsType == 'grid',
                'main-list-element': elementsType == 'list',
                'filter-block': elem.disable,
              }"
              :style="indexElem >= elementsLimit ? { display: 'none' } : {}"
              v-for="(elem, indexElem) in filteredItems"
              :key="'main-container-element-' + indexElem"
            >
              <div
                class="main-container-images"
                @click="elementRedirect(elem.type, elem.id, elem.download, elem.tags, elem.disable)"
              >
                <img draggable="false" class="main-container-element-img" :src="setElementImg(elem.img)" />
                <div :title="elem.type">
                  <img
                    draggable="false"
                    class="main-container-element-icon"
                    v-if="elementsType == 'grid'"
                    :src="setIcon(elem.type)"
                  />
                </div>
              </div>
              <div class="main-container-texts">
                <div
                  class="main-title-container"
                  @click="elementRedirect(elem.type, elem.id, elem.download, elem.tags, elem.disable)"
                >
                  <p class="title" :style="{ color: items.mainColor }">{{ setTitle(elem.type) }}</p>
                  <p class="title-content" v-html="elem.title"></p>
                </div>
                <div v-if="elementsType == 'list'" class="icon-and-tag-container">
                  <div :title="elem.type">
                    <img class="main-container-element-icon" :src="setIcon(elem.type)" />
                  </div>
                  <div class="tag" :style="{ backgroundColor: items.mainColor }">
                    <div
                      class="tag-text"
                      v-for="(tag, tagId) in elem.tags"
                      :key="'tag-id-' + tagId"
                      @click="setTagAsFilter(tag.id)"
                    >
                      <span style="font-weight: bold">
                        {{ tag.id }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="elementsType == 'grid'" class="tag" :style="{ backgroundColor: items.mainColor }">
                <span style="width: 100%; overflow: hidden; line-height: 1.3vmin">
                  <div
                    v-for="(tag, tagId) in elem.tags"
                    :key="'tag-id-' + tagId"
                    style="padding: 0 5px; display: inline-block"
                    @click="setTagAsFilter(tag.id)"
                  >
                    <span style="white-space: nowrap; font-weight: bold">{{ tag.id }}</span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <!-- <div class="container-elements-footer">
            <span v-if="filteredItems">1-{{ enableElements }} z {{ filteredItems.length }} zasobów</span>
            <span
              class="container-elements-footer-more"
              @click="moreElements()"
            >pokaż więcej wyników</span>
          </div>-->
        </div>
        <div id="footer">
          <div class="footer-all-right">
            <span>© GRUPA MAC S.A.</span>
          </div>
          <div class="footer-links">
            <div
              v-for="(itm, indexSocial) in socialMedia"
              :key="'footer-link-' + indexSocial"
              class="footer-link"
              :style="itm.style"
              @click="openUrl(itm.href, itm.click)"
            >
              <span v-if="itm.text">{{ itm.text }}</span>
              <img v-if="itm.img" :src="itm.img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import INFO from '../../config/info/tablice.js';
import _ from 'lodash';
import VueWordCloud from 'vuewordcloud';
import MbEditorPage from './MbEditorPage/MbEditorPage';
import MbCustomRoulette from '__mainSrcDir/components/TrGame/v4/GameEngines/MbRoulette/MbCustomRoulette/MbCustomRoulette';
import MbCustomCoding from '__mainSrcDir/components/TrGame/v4/GameEngines/MbCoding/MbCustomCoding/MbCustomCoding';
export default {
  name: 'mb-grid',
  components: { VueWordCloud, MbCustomRoulette, MbCustomCoding, MbEditorPage },
  data: function () {
    return {
      filtersMustContain: [],
      editorPageState: false,
      collapseItems: [],
      gridIconHover: false,
      homeIconStatus: false,
      gameId: '',
      customRouletteState: false,
      customCodingState: false,
      monographStatus: false,
      elementsType: 'grid',
      activeFilter: [],
      socialMedia: [
        {
          text: 'Kontakt',
          href: 'https://www.mac.pl/kontakt',
          style: 'border-right: 1px solid black',
        },
        {
          text: 'Strona redakcyjna',
          // href: 'https://www.mac.pl',
          click: 'showEditorPage',
          // style: 'border-right: 1px solid black',
        },
      ],
      filters: {
        types: [],
        tags: [],
      },
      containerScroll: 0,
      tagsClousType: 50,
      enableElements: 18,
      mediaBarObj: null,
      items: null,
      filteredItems: null,
      mediaState: false,
      filterItems: null,
      canIHandleScroll: true,
      elementsLimit: 24,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  beforeMount() {
    this.init();
  },
  mounted() {
    if (this.containerScroll) {
      let element = document.getElementById('container');
      element.scrollTop = this.containerScroll;
    }
  },
  methods: {
    handleScroll(event) {
      let scroll = event.target.scrollTop;
      let height = event.target.scrollHeight;
      let elemHeight = event.target.clientHeight;
      if (height - scroll - elemHeight * 0.2 < elemHeight && this.filteredItems.length > this.elementsLimit)
        this.elementsLimit += 24;
    },
    setTitle(type) {
      if (type == 'pdf') {
        return 'Do wydruku';
      }
      return 'Polecenie';
    },
    setTagAsFilter(tag) {
      this.filterItems.forEach((filter) => {
        filter.items.forEach((it) => {
          // console.log('dsa');
          if (it.text == tag) {
            this.setFilters(it.type, it.disable, this.checkFilterStatus(it.type), it.mustContain);
          }
        });
      });
      //
    },
    showEditorPage() {
      this.editorPageState = true;
    },
    setTags(array) {
      let value = '';
      array.forEach((tag) => {
        value = value + '<span style="padding: 0 5px">' + tag.id + '</span>';
      });
      return value;
    },
    setFilteredItemsById() {
      let array = _.cloneDeep(this.items.elements);
      let tmpArray = [];
      let tmpTags = [];
      array.forEach((el) => {
        if (el.tags.some((x) => x.id.includes(this.gameId.toUpperCase()))) tmpArray.push(el);
      });
      this.filteredItems = tmpArray;
    },
    findById() {
      if (this.gameId != '') {
        this.setFilteredItemsById();
      } else {
        this.setFilteredItems();
      }
    },
    setElementImg(img) {
      if (img && img != '') {
        return img;
      } else return require('./assets/imgTmp.png');
    },
    clearFilters() {
      this.filteredItems = this.setStartItems();
      this.activeFilter = [];
    },
    createTagArray(value) {
      let array = [];
      let tmpTags = [];
      this.filteredItems.forEach((el) => {
        el.tags.forEach((tag) => {
          if (tmpTags.some((x) => x.tag == tag.id)) {
            tmpTags.forEach((ta) => {
              if (ta.tag == tag.id) {
                ta.value = ta.value + 1;
              }
            });
          } else {
            if (!tag.id.includes('ID')) tmpTags.push({ tag: tag.id, value: 1 });
          }
        });
      });
      tmpTags.forEach((el) => {
        // if (this.tagsClousType < el.value) array.push([el.tag, this.tagsClousType]);
        array.push([el.tag, 50]);
      });

      return array;
    },
    checkFilterCollapseStatus(id) {
      return this.collapseItems.some((x) => x == id);
    },
    setFilterCollapse(id) {
      if (!this.collapseItems.some((x) => x == id)) {
        this.collapseItems.push(id);
      } else {
        let array = [];
        this.collapseItems.forEach((el) => {
          if (el.includes(id)) array.push(el);
        });
        array.forEach((arr) => {
          this.collapseItems.splice(this.collapseItems.indexOf(arr), 1);
        });
      }
    },
    setFilter(filter, state) {
      if (state) {
        if (!this.activeFilter.some((x) => x == filter)) {
          this.activeFilter.push(filter);
          this.setFilteredItems();
        }
      } else {
        if (this.activeFilter.some((x) => x == filter)) {
          this.activeFilter.splice(this.activeFilter.indexOf(filter), 1);
          if (this.activeFilter.length != 0) this.setFilteredItems();
          else this.clearFilters();
        }
      }
    },
    setFilters(filters, disable, state, mustContain) {
      if (mustContain) {
        filters.forEach((filter) => {
          this.setFilterMustContain(filter);
        });
      } else {
        if (!disable) {
          filters.forEach((filter) => {
            this.setFilter(filter, !state);
          });
        }
      }
    },
    checkArrays(arr1, arr2) {
      return arr1.every((r) => arr2.includes(r));
    },
    checkArraysWithoutLengthCheck(arr1, arr2) {
      const [smallArray, bigArray] = arr1.length < arr2.length ? [arr1, arr2] : [arr2, arr1];
      return smallArray.some((c) => bigArray.includes(c));
    },
    checkArrayContainAllWithoutLengthCheck(arr1, arr2) {
      const [smallArray, bigArray] = arr1.length < arr2.length ? [arr1, arr2] : [arr2, arr1];
      return smallArray.every((c) => bigArray.includes(c));
    },

    setFilteredItems() {
      // let array = _.cloneDeep(this.items.elements);
      let array = _.cloneDeep(this.setStartItems());
      let tmpArray = [];
      let tmpTags = [];
      array.forEach((el) => {
        if (
          this.checkArraysWithoutLengthCheck(
            el.tags.map((it) => {
              return it['id'];
            }),
            this.activeFilter
          )
        )
          tmpArray.push(el);
      });
      this.filteredItems = tmpArray;
    },
    chceckItems(items) {
      let value = true;
      items.forEach((el) => {
        if (el.value && !el.disable) {
          if (this.activeFilter.includes(el.type));
          else value = false;
        }
      });
      return value;
    },
    checkFilterStatus(type) {
      if (type) {
        if (this.checkArrays(type, this.activeFilter)) {
          return true;
        } else return false;
      }
      return false;
    },
    setImg(type) {
      if (type) {
        if (this.checkArrays(type, this.filtersMustContain)) {
          return require('./assets/trueIcon.png');
        } else {
          if (this.checkArrays(type, this.activeFilter)) {
            return require('./assets/trueIcon.png');
          } else return require('./assets/falseIcon.png');
        }
      }

      return require('./assets/falseIcon.png');
    },
    setImgCollapse(type) {
      if (type) {
        if (this.collapseItems.some((x) => x == type)) {
          return require('./assets/on.png');
        }
      }
      return require('./assets/off.png');
    },
    setGameLevel(arr) {
      if (arr.some((x) => x.id == '6 latek')) {
        this.$store.commit('SET_GAME_LEVEL', '6 latek');
      } else if (arr.some((x) => x.id == '5 latek')) {
        this.$store.commit('SET_GAME_LEVEL', '5 latek');
      } else if (arr.some((x) => x.id == '4 latek')) {
        this.$store.commit('SET_GAME_LEVEL', '4 latek');
      } else if (arr.some((x) => x.id == '3 latek')) {
        this.$store.commit('SET_GAME_LEVEL', '3 latek');
      } else {
        this.$store.commit('SET_GAME_LEVEL', null);
      }
    },
    elementRedirect(type, id, download, tags, disable) {
      if (!disable) {
        if (download && type == 'pdf') {
          this.dowloadUrl('doc/' + download);
        } else {
          if (type == 'plansza') {
            this.$store.commit('CHANGE_MULTIBOOK_TYPE', this.$store.getters.multibookType);
            let element = document.getElementById('container');
            this.containerScroll = element.scrollTop;
            this.$store.commit('SET_GRID_DATA', _.cloneDeep(this.$data));
            this.redirectPresentaionByID(id);
          } else {
            this.$store.commit('CHANGE_MULTIBOOK_TYPE', this.$store.getters.multibookType);
            let element = document.getElementById('container');
            this.containerScroll = element.scrollTop;
            this.$store.commit('SET_GRID_DATA', _.cloneDeep(this.$data));
            this.setGameLevel(tags);
            // let gameObj = this.$store.getters[`${_.upperFirst(this.$store.getters.multibookType)}/gameByID`](id);
            // if (gameObj) {
            //   this.$store.dispatch('newGame', gameObj);
            //   this.redirect('game-view');
            // } else {
            //   throw `Game with id ${id} not exist in games (${this.$store.getters.multibookType}) !`;
            // }
            this.redirectGameByID(id);
          }
        }
      }
    },
    dowloadUrl(file) {
      if (file) {
        this.openUrl(window.location.origin + '/' + file);
      }
    },
    redirect(router) {
      this.$router.push({ name: router });
    },
    redirectGameByID(id) {
      // console.log(`/game/by/id/${id}`);
      if (Array.isArray(id)) {
        this.$store.commit('SET_STAGES', id);
        this.$store.commit('CHANGE_CURRENT_STAGE', 0);
        this.$router.push(`/game/by/id/${id[0]}`);
      } else {
        this.$router.push(`/game/by/id/${id}`);
      }
    },
    redirectPresentaionByID(id) {
      // console.log(`/game/by/id/${id}`);
      this.$router.push(`/presentation/by/id/${id}`);
    },
    setContainerStyle() {
      if (this.elementsType == 'grid') this.elementsType = 'list';
      else this.elementsType = 'grid';
    },
    moreElements() {
      this.enableElements = this.enableElements + 6;
      if (this.filteredItems.length < this.enableElements) {
        this.enableElements = this.filteredItems.length;
      }
    },
    setIcon(type) {
      let icon = null;
      try {
        icon = require(`__mainSrcDir/assets/icons/grid/elements/${type}-80px.png`);
      } catch {
        console.log(
          '%c' + type + 'Icon MbGrid- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return icon;
    },
    openUrl(link, click) {
      if (link) {
        if (this.$store.getters.isWeb) {
          window.open(link, '_blank');
        } else {
          this.$electron.shell.openExternal(link);
        }
      }
      if (click) {
        if (click == 'showEditorPage') {
          this.editorPageState = true;
        }
      }
    },
    setPath() {
      if (this.mediaState) {
        return 'M 75 20, 20 50, 75 80Z';
      } else {
        return 'M 75 50, 25 20, 25 80Z';
      }
    },
    setSvgPath() {
      if (this.elementsType == 'list') {
        return 'M 15 15, 15 25, 25 25, 25 15Z\
M 40 15, 40 25, 50 25, 50 15Z\
M 65 15, 65 25, 75 25, 75 15Z\
M 15 40, 15 50, 25 50, 25 40Z\
M 40 40, 40 50, 50 50, 50 40Z\
M 65 40, 65 50, 75 50, 75 40Z\
M 15 65, 15 75, 25 75, 25 65Z\
M 40 65, 40 75, 50 75, 50 65Z\
M 65 65, 65 75, 75 75, 75 65Z';
      } else {
        return 'M 15 15, 15 25, 25 25, 25 15Z\
M 40 15, 40 25, 75 25, 75 15Z\
M 40 15, 40 25, 75 25, 75 15Z\
M 15 40, 15 50, 25 50, 25 40Z\
M 40 40, 40 50, 75 50, 75 40Z\
M 40 40, 40 50, 75 50, 75 40Z\
M 15 65, 15 75, 25 75, 25 65Z\
M 40 65, 40 75, 75 75, 75 65Z\
M 40 65, 40 75, 75 75, 75 65Z';
      }
    },
    redirectMain() {
      this.$store.commit('SET_GRID_DATA', null);
      this.$router.push(`/`);
    },
    addTagToFilters(tag, array) {
      if (array) {
        array.forEach((el) => {
          if (el.type == tag) {
            if (el.value) el.value = el.value + 1;
            else el.value = 1;
          }
          if (el.items) {
            if (el.items.some((x) => x.type == tag)) {
              if (el.value) el.value = el.value + 1;
              else el.value = 1;
              this.addTagToFilters(tag, el.items);
            }
          }
        });
      }
    },
    setFiltersMustContain(filters) {
      filters.forEach((filter) => {
        this.setFilterMustContain(filter);
      });
    },
    setFilterMustContain(filter) {
      if (!this.filtersMustContain.some((x) => x == filter)) {
        this.filtersMustContain.push(filter);
      } else {
        this.filtersMustContain.splice(this.filtersMustContain.indexOf(filter), 1);
      }
      this.items.element = this.setStartItems();
      this.filteredItems = this.setStartItems();
    },
    filterFindCheckFromStart(array) {
      if (array) {
        array.forEach((el) => {
          if (el.check) {
            if (el.value) this.setFiltersMustContain(el.type);
          }
        });
      }
    },
    initFilterCheckFromStart(array) {
      if (array) {
        array.forEach((filter) => {
          this.filterFindCheckFromStart(filter.items);
        });
      }
    },
    initFilterArrayItems(array, index, padding, collapseDepends) {
      array.forEach((arr) => {
        this.filterItems[index].items.push({
          type: arr.type,
          value: 0,
          text: arr.text,
          padding: padding,
          check: arr.check,
          disable: arr.disable,
          collapse: arr.collapse,
          collapseDepends: collapseDepends,
          mustContain: arr.mustContain,
          id: arr.id,
        });
        if (arr.items) this.initFilterArrayItems(arr.items, index, padding * 2, arr.id);
      });
    },
    initFilterArray(array) {
      this.filterItems = [];
      array.forEach((arr, index) => {
        this.filterItems.push({
          title: arr.title,
          items: [],
        });
        this.initFilterArrayItems(arr.items, index, 0.47);
      });
    },
    initFilterValue(filters, items) {
      items.forEach((el) => {
        el.tags.forEach((tag) => {
          filters.forEach((filter) => {
            filter.items.forEach((filterIt) => {
              // console.log(filterIt.value);
              if (filterIt.type.some((x) => x == tag.id)) {
                filterIt.value = filterIt.value + 1;
              }
            });
          });
        });
      });
    },
    initPushIdToTags(array) {
      array.forEach((el) => {
        // console.log(el);
        if (el.tags[0].id != el.id) {
          if (Array.isArray(el.id)) {
            if (el.tags[0].id != el.id.join(' ')) el.tags.unshift({ id: el.id.join(' '), text: '' });
          } else {
            el.tags.unshift({ id: el.id, text: '' });
          }
        }
        // console.log(el);
      });
    },
    itemsSort(a, b) {
      if (a.disable && !b.disable) {
        return 1;
      }
      if (b.disable && !a.disable) {
        return -1;
      }
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    },
    setStartItems() {
      let array = _.cloneDeep(this.items.elements);
      let tmpArray = [];
      let tmpTags = [];
      array.forEach((el) => {
        if (
          this.checkArraysWithoutLengthCheck(
            el.tags.map((it) => {
              return it['id'];
            }),
            this.filtersMustContain
          )
        )
          tmpArray.push(el);
      });
      if (tmpArray.length == 0) {
        return array;
      }
      return tmpArray;
    },
    init() {
      this.items = this.$router.currentRoute.params.items;
      try {
        this.filtersMustContain = this.items.filterMustContain;
        this.items.elements = this.items.elements.sort(this.itemsSort);
        this.initPushIdToTags(this.items.elements);
        let tmpFilters = _.cloneDeep(this.items.filters);
        this.items.element = this.setStartItems();
        this.filteredItems = this.setStartItems();
        this.initFilterArray(tmpFilters);
      } catch (err) {
        console.log(err);
      }
      if (!this.items) {
        this.redirectMain();
      } else {
        this.mediaBarObj = {
          mediaBar: this.items.mediaBar,
          media: this.items.media,
        };
        if (this.items.mainColor) this.$store.commit('SET_MAIN_COLOR', this.items.mainColor);
        // this.initFilters();
      }
      this.initFilterValue(this.filterItems, this.filteredItems);
      this.initFilterCheckFromStart(this.filterItems);
      // this.items.element = this.setStartItems();
      // this.filteredItems = this.setStartItems();
      this.setData();
    },
    setData() {
      let data = this.$store.getters.getGridData;
      if (data) {
        // this.devTool = data.devTool;
        this.gridIconHover = data.gridIconHover;
        this.homeIconStatus = data.homeIconStatus;
        this.gameId = data.gameId;
        this.customRouletteState = data.customRouletteState;
        this.customCodingState = data.customCodingState;
        this.monographStatus = data.monographStatus;
        this.elementsType = data.elementsType;
        this.activeFilter = data.activeFilter;
        this.filters = data.filters;
        this.tagsClousType = data.tagsClousType;
        this.enableElements = data.enableElements;
        this.mediaBarObj = data.mediaBarObj;
        this.items = data.items;
        this.filteredItems = data.filteredItems;
        this.mediaState = data.mediaState;
        this.filterItems = data.filterItems;
        this.containerScroll = data.containerScroll;
        this.collapseItems = data.collapseItems;
        this.elementsLimit = data.elementsLimit;
        this.filtersMustContain = this.filtersMustContain;
      }
      this.$store.commit('SET_GRID_DATA', null);
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
    color() {
      return this.$store.getters.getMainColor;
    },
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
    homeIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/home-48.png`);
      } catch {
        console.log('%cHomeIcon MbGrid- error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
      return null;
    },
    homeOnIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/home-on-48.png`);
      } catch {
        console.log(
          '%cHomeOnIcon MbGrid- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    MAClogo() {
      try {
        return require(`__mainSrcDir/config/homePage/grid/bcg/macLogo.png`);
      } catch {
        console.log('%cMAClogo MbGrid- error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
      return null;
    },
    devTool() {
      return this.$store.getters.devTool;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variable'
$break-large: 1400px
#mb-grid
  display: flex
  align-items: center
  justify-content: flex-start
  flex-direction: column
  width: 100vw
  height: 100vh
  background: white
  overflow: hidden
  // background: white
  font-family: $gameFontFamily
  #container
    // position: absolute
    width: 100%
    height: 100%
    // top: 14%
    // padding: 1%
    display: flex
    align-items: flex-start
    justify-content: space-evenly
    overflow-y: scroll
    background-attachment: fixed
    background-size: cover
    .container-filter
      // height: 90%
      width: 21%
      background: white
      z-index: 2
      display: flex
      align-items: center
      flex-direction: column
      justify-content: space-between
      .container-tite
        display: flex
        // padding: 10px
        padding-top: 10px
        padding-left: 27px
        align-items: center
        justify-content: flex-start
        width: 100%
        font-weight: bold
        height: 5.5vh
        color: white
        font-size: 3vmin
      .container-filters
        padding-left: 17px
        width: 100%
        height: 70%
        background: rgba(255,255,255,.5)
        .container-filters-header
          font-weight: bold
          width: 100%
          height: 10%
          padding: 10px
          margin: 2.5vmin 0px
          display: flex
          align-items: center
          justify-content: space-between
          p
            margin: 0
            font-size: 2.2vmin
          span
            font-weight: normal
            text-align: right
            font-size: 1.5vmin
            cursor: pointer
        .container-filters-header-filter
          // overflow-y: auto
          height: 90%
          .filter-main
            width: 100%
            min-height: 30px
            padding: 0px 0px 10px 10px
            margin-bottom: 2vmin
            .filter-text
              font-weight: bolder
              width: 100%
              min-height: 30px
              font-size: 1.9vmin
            .filter-disable
              color: black !important
              opacity: .5
              cursor: auto !important
              &:hover
                color: black !important
                background: rgba(0,0,0,0) !important
            .filter
              font-weight: normal
              width: 100%
              margin: 1vmin 0px
              position: relative
              cursor: pointer
              display: flex
              align-items: center
              justify-content: flex-start
              &:hover
                color: var(--color)
                // background: rgba(0,0,0,.2)
              img
                // margin: 0px 4px
                margin-right: 1.2vmax
                width: 1vmax
                height: 1vmax
                transition: .3s
              .filter-box
                font-size: 1.6vmin
                display: flex
                align-items: center
                justify-content: flex-start
                height: 100%
                width: calc(100% - 2.5vmin - 8px)
                // overflow: hidden
                // white-space: nowrap
                // text-overflow: ellipsis
                @media screen and (min-height: 1600px)
                  font-size: 1.3vmin
      .container-tags
        width: 100%
        margin-top: 1vh
        height: calc(50vh * .8 * .9)
        background: rgba(255,255,255,.3)
        padding: 10px 27px
        display: flex
        align-items: center
        flex-direction: column
        justify-content: space-between
        .container-tags-title
          font-weight: bold
          position: absolute
          left: 27px
          // height: 10%
          text-align: left
          font-family: $gameFontFamily
          font-size: 24px

    .container-elements
      // height: 90%
      z-index: 2
      // background: white
      width: 85%
      .container-elements-header
        width: 100%
        height: 10%
        position: relative
        .style-changer
          position: absolute
          right: 0
          top: 0
          right: 24px
          width: calc(3vmax * .8)
          height: calc(3vmax * .8)
          transition: .5s
          cursor: pointer
          &:hover
            // background: #ececec
        .container-elements-header-img
          height: 100%
          position: absolute
          right: 0
          top: 0
          display: flex
          align-items: center
          margin: 0px 20px
          // animation: .5s 1.5s banerShow 1 linear backwards
      .containter-content
        width: 100%
        // min-height: 100%
        // overflow-y: scroll
        .container-elements-main
          width: 100%
          min-height: 94%
          margin-bottom: 2%
        .container-elements-main-list
          display: grid
          width: 99%
          grid-template-columns: auto
          padding: 0% 1% 2% 1%
          // grid-column-gap: 2%
          grid-row-gap: 20px
          .main-container-disable
            display: none !important
          .main-list-element
            // display: inline-block
            box-shadow: 0px 1px 7px rgba(0,0,0, 0.2)
            border-radius: 10px
            width: 100%
            height: 20vh
            background: white
            // transition: .5s
            cursor: pointer
            position: relative
            display: flex
            align-items: center
            justify-content: flex-start
            animation: .7s 0s elementShow 1 linear backwards
            &:hover
              background: #ececec
              .main-container-element-icon
                border: 5px solid #ececec !important
            .main-container-images
              max-width: 25%
              min-height: 100%
              display: inline-flex
              display: flex
              align-items: center
              justify-content: center
              .main-container-element-img
                max-width: 80%
                max-height: 80%
            .main-container-texts
              width: 100%
              overflow: hidden
              display: flex
              align-items: flex-start
              justify-content: flex-start
              flex-direction: column
              height: calc(100% - 20px)
              // width: calc(100% - 25%)
              margin: 10px

              .main-title-container
                display: flex
                align-items: flex-start
                justify-content: inherit
                width: 100%
                height: 100%
                flex-direction: column

              .title, .title-content, .tag
                font-family: $gameFontFamily
                margin: 5px 10px
              .title
                font-size: 1.7vmin
                margin: 0px 10px
                font-weight: 600
              .title-content
                font-size: 1.6vmin
                margin: 0px 10px
                min-height: calc(6vmin - 10px)
              .icon-and-tag-container
                display: flex
                width: 100%
                align-items: center
                justify-content: flex-start
                .main-container-element-icon
                  border: 5px solid white
                  height: 100%
                  object-fit: contain
                  // margin-bottom: 10px
                .tag
                  font-size: 1.6vmin
                  height: 5vmin
                  // white-space: nowrap
                  // overflow: hidden
                  display: flex
                  align-items: center
                  color: white
                  width: 100%
                  // justify-content: space-between
                  // padding: 0% 1% 0% 1%
                  .tag-text
                    display: flex
                    align-items: center
                    height: 100%
                    font-size: 1.6vmin
                    // white-space: nowrap
                    padding: 0% 5px
                // color: gray
        .container-elements-main-grid
          display: grid
          width: 99%
          grid-template-columns: 32% 32% 32%
          padding: 0% 1% 2% 1%
          grid-column-gap: 2%
          grid-row-gap: 20px
          .main-container-element
            box-shadow: 0px 1px 7px rgba(0,0,0, 0.2)
            border-radius: 10px
            display: inline-block
            position: relative
            margin: 1% 1.5%
            width: 100%
            height: 100%
            margin-bottom: 5vmin
            // min-height: 45vh
            background: white
            // transition: .5s
            cursor: pointer
            animation: .7s 0s elementShow 1 linear backwards
            &:hover
              background: #ececec
              .main-container-element-icon
                border: 5px solid #ececec !important
            .main-container-images
              position: relative
              .main-container-element-img
                padding: 3% 7% 0% 7%
                width: calc(100% - 20px)
                margin: 10px
              .main-container-element-icon
                border: 5px solid white
                position: absolute
                bottom: -0.5vmax
                right: 0.5vmax
                width: 3vmax
                height: 3vmax
            .main-container-texts
              margin: 0px 3%
              .title, .title-content, .tag
                font-family: $gameFontFamily
                margin: 5px 10px
              .title
                font-size: 1.7vmin
                margin: 0px 10px
                font-weight: 600
              .title-content
                font-size: 1.6vmin
                margin: 0px 10px
                min-height: 6vmin
            .tag
              position: absolute
              border-radius: 0 0 10px 10px
              bottom: 0
              left: 0
              width: 100%
              font-size: 1.2vmin
              height: 5vmin
              color: white
              // text-align: center
              padding: 0% 3%
              overflow: hidden
              display: flex
              align-items: center
              justify-content: space-between
              span
                width: 100%
                overflow: hidden
                // white-space: nowrap
        .container-elements-footer
          width: 100%
          height: 6%
          padding: 0px 50px
          position: relative
          .container-elements-footer-more
            position: absolute
            bottom: 0
            width: 30%
            left: calc(50% - 15%)
            font-size: 120%
            text-align: center
            cursor: pointer
            &:hover
              color: #004899
    .container-bcg
      width: 100%
      height: 100%
      top: 0
      left: 0
      position: absolute
      background-attachment: absolute
  #header
    width: 100%
    // height: 14%
    // position: absolute
    // left: 0
    background: white
  #footer
    display: flex
    align-items: center
    justify-content: space-between
    height: 6%
    background: white
    .footer-all-right
      display: flex
      height: 100%
      align-items: center
    .footer-links
      display: flex
      height: 100%
      align-items: center
      .footer-link
        display: inline-block
        font-size: 1.5vmin
        margin: 10px 0px
        padding: 0px 10px
        transition: .5s
        cursor: pointer
        &:hover
          color: #004899
  #header
    top: 0
    z-index: 3
    text-align: center
    position: relative
    box-shadow: 0px 1px 7px rgba(0,0,0, 0.2)
    .header-img
      width: 100%
      // height: 100%
      top: 0
      // animation: .7s 1s headerImgShow 1 linear backwards
    .header-logo-img
      height: 70%
      position: absolute
      top: 15%
      left: 1.7%
      // animation: .7s 1.3s homeLogoShow 1 linear backwards
    .header-home-icon
      width: 3vmax
      position: absolute
      top: calc(50% - 3vmax/2)
      right: 39px
      transition: .5s
      transform: scale(.8)
      cursor: pointer
      // animation: .7s .5s homeIconShow 1 linear backwards
      // &:hover
      //   transform: scale(1)
.filter-block
  cursor: auto !important
  filter: grayscale(1)
  background: white !important
.media-bar-fade-leave-active, .media-bar-fade-enter-active
  transition: all .5s ease-in-out
.media-bar-fade-leave-to, .media-bar-fade-enter
  transform: translateX(-110%)
  opacity: 0

@keyframes elementShow
  0%
    opacity: 0
    transform: translateY(10%)
  100%
    opacity: 1

#container::-webkit-scrollbar-track
  -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2)
  background-color: white

#container::-webkit-scrollbar
  width: 20px
  background-color: white

#container::-webkit-scrollbar-thumb
  background-color: var(--color)
  border: 2px solid var(--color)

// .container-filter::-webkit-scrollbar-track
//   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)
//   background-color: red

// .container-filters-header-filter::-webkit-scrollbar
//   width: 6px
//   background-color: lightgray

// .container-filters-header-filter::-webkit-scrollbar-thumb
//   background-color: gray
//   border: 2px solid gray
.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  opacity: 0
</style>
